import * as types from './ActionTypes';
import { activity, errors, smsConsumeRecord, iconSwitch } from '../services';
import { Message, MessageBox } from 'element-ui';
import config from '@/services/config';

export const state = {
	isLoading: false,
	imgItems: [],
	liveListView: 0,
	concernListView: 0,
	liveManageView: 0,
	classify: [],
	currentActive: {
		iconSwitchShow: {},
	},
	isSingleActivity: false, // 是否为单场直播间
	invoicePage: 1,
	changeFormDataStatus: false,
	streamingStatus: false,
	updatedLiveData: [],
	liveUpdateDialog: false,
	noticeActive: false,
	notReadMsgNum: 0,
	noticePage: 1,
	noticeId: null,
	// 最低提现金额
	MINIMUM_AMOUNT: 0.3,
	// 服务费 x%
	RATIO: 0.8,
	userHaveSelfMch: false, // 用户是否设置商户
	isOurwillDomain: true, // 是否为映目域名
	activityDomain: null, // 直播间域名
	haveSelfMch: false, // 直播间是否设置商户
	payToUser: false, // 直播间是否开通企业付款到零钱
	smsAssets: null,
	haveTrueSelfMch: false, // 直播间是否存在独立商户
};

export const mutations = {
	[types.STREAMING_STATUS](st, data) {
		st.streamingStatus = data;
	},
	[types.VIEW_IMG](st, data) {
		// console.log(data);
	},
	[types.LIVE_LIST_VIEW](state, data) {
		state.liveListView = data;
	},
	[types.CONCERN_LIST_VIEW](state, data) {
		state.concernListView = data;
	},
	[types.CLASSIFY](state, data) {
		state.classify = data;
	},
	[types.LIVE_MANAGE_VIEW](state, data) {
		state.liveManageView = data;
	},
	[types.SET_CURRENT_ACTIVE](state, data) {
		state.currentActive = data;
	},
	[types.SET_ACTIVITY_BGM](state, data) {
		if (!state.currentActive) {
			return;
		}
		state.currentActive.activityBgm = data;
	},
	[types.SET_LIVE_CONTENT](state, data) {
		if (state.currentActive.id) {
			for (let key in data) {
				if (data[key] && typeof data[key] === 'object') {
					for (let Key in data[key]) {
						if (!state.currentActive[key]) {
							state.currentActive[key] = [];
						}

						state.currentActive[key][Key] = data[key][Key];
					}
				} else {
					state.currentActive[key] = data[key];
				}
			}
		}
	},
	[types.SET_INVOICE_PAGE](state, data) {
		state.invoicePage = data;
	},
	[types.CHANGE_FORM_DATA_STATUS](state, data) {
		state.changeFormDataStatus = data;
	},
	[types.UPDATED_LIVE_DATA](state, data) {
		state.updatedLiveData = data;
	},
	[types.SET_NOTICE_ACTIVE](st, data) {
		st.noticeActive = data;
	},
	[types.SET_NOT_READ_MSG_NUM](st, data) {
		st.notReadMsgNum = data;
	},
	[types.SET_NOTICE_PAGE](st, data) {
		st.noticePage = data;
	},
	[types.SET_NOTICE_ID](st, data) {
		st.noticeId = data;
	},
	LIVE_UPDATE_DIALOG(state, data) {
		state.liveUpdateDialog = data;
	},
	[types.SET_IS_OURWILL_DOMAIN](state, status) {
		state.isOurwillDomain = status;
	},
	[types.SET_ACTIVITY_DOMAIN](state, doamin) {
		state.activityDomain = doamin;
	},
	SET_USER_HAVE_SELF_MCH(state, status) {
		state.userHaveSelfMch = status;
	},
	SET_HAVE_SELF_MCH(state, status) {
		state.haveSelfMch = status;
	},
	SET_PAY_TO_USER(state, status) {
		state.payToUser = status;
	},
	SET_SMS_ASSETS(state, payload) {
		state.smsAssets = payload;
	},
	SET_HAVE_TRUE_SELF_MCH(state, status) {
		state.haveTrueSelfMch = status;
	},
	SET_IS_SINGLE_ACTIVITY(state, status) {
		state.isSingleActivity = status;
	},
};
export const actions = {
	getCurrentActive({ state, dispatch, commit }, id) {
		return activity
			.getActivityById(id)
			.then(({ data, ok }) => {
				if (ok) {
					state.currentActive = data.data;
					dispatch('userPower/getActivityUserPowerType', data.data.userId);
					dispatch('getActivitySingleStatus', id);
				}
			})
			.catch(errors);
	},
	async getActivitySingleStatus({ commit }, id) {
		try {
			const { data, ok } = await activity.getActivitySingleStatus(id);
			if (!ok) {
				return;
			}
			commit('SET_IS_SINGLE_ACTIVITY', data.data);
		} catch (error) {
			errors(error);
		}
	},
	async updateMajor({ state, dispatch, commit }, self) {
		commit('LIVE_UPDATE_DIALOG', true);
	},
	async releaseHandle({ state, dispatch }, self) {
		try {
			const id = self.id ? self.id : state.currentActive.id;
			const { data, ok } = await activity.openActivity(id);
			if (!ok) {
				return;
			}
			if (data.flag == -1) {
				Message.error(data.msg);
			} else {
				Message.success({
					duration: 800,
					message: data.msg,
				});
				if (self.id) {
					self.status = 1;
					self.isTest = 1; //这里有重复的问题
				} else {
					self.isRelease = 1;
					self.isOn = true;
					dispatch('getCurrentActive', state.currentActive.id);
				}
				dispatch('saveUser');
			}
		} catch (e) {
			errors(e);
		}
	},
	updateRelease({ state, dispatch, commit }, self) {
		// debugger;
		dispatch('getUser').then((user) => {
			const active = self.id ? self : state.currentActive;
			// if (user.remainingDays <= 0 && active.isPay && !active.isTest) {
			// 	Message.error('您还没有购买直播场次，请先购买！');
			// 	setTimeout(() => {
			// 		commit('SET_MAJOR_STATUS', true);
			// 	}, 500);
			// } else if ((user.remainingDays > 0 || user.licenseType === 1) && active.isPay && !active.isTest) {
			// 	MessageBox.confirm(
			// 		`<h4>当前为试用状态，确定转换成专业版吗？</h4>
			// 		<span>发布后扣除相应场次专业版直播授权</span>`,
			// 		'确定转换',
			// 		{
			// 			closeOnClickModal: false,
			// 			confirmButtonText: '转换',
			// 			cancelButtonText: '取消',
			// 			type: 'warning',
			// 			dangerouslyUseHTMLString: true,
			// 			customClass: 'confimDelete'
			// 		}
			// 	)
			// 		.then(() => {
			// 			dispatch('releaseHandle', self);
			// 		})
			// 		.catch(() => {
			// 			// self.isRelease = 0;
			// 			// self.isOn = false;
			// 		});
			// } else {
			dispatch('releaseHandle', self);
			// }
		});
	},
	// async updateReleaseItem({ dispatch, commit }, obj) {
	// 	dispatch('getUser').then(async user => {
	// 		if (user.remainingDays <= 0 && obj.item.isPay && !obj.item.isTest) {
	// 			Message.error('您还没有购买直播场次，请先购买！');
	// 			setTimeout(() => {
	// 				commit('SET_MAJOR_STATUS', true);
	// 			}, 500);
	// 		} else {

	// 			try {
	// 				const { data, ok } = await activity.openActivity(obj.item.id);
	// 				if (!ok) {
	// 					return;
	// 				}
	// 				Message.success({
	// 					duration: 1000,
	// 					message: data.msg
	// 				});
	// 				obj.item.status = 1;
	// 				dispatch('saveUser');
	// 			} catch (e) {
	// 				errors(e);
	// 			}
	// 		}
	// 	});
	// }
	async getUserHaveSelfMch({ commit }) {
		try {
			const { data, ok } = await activity.getUserHaveSelfMch();
			if (!ok) {
				return;
			}
			const { haveSelfMch, haveTrueSelfMch } = data.data;
			commit('SET_USER_HAVE_SELF_MCH', haveTrueSelfMch);
		} catch (error) {
			errors(error);
		}
	},
	async getActivityHaveSelfMch({ commit }, activityId) {
		try {
			const { data, ok } = await activity.getActivityHaveSelfMch(activityId);
			if (!ok) {
				return;
			}
			const { haveSelfMch, haveTrueSelfMch, payToUser } = data.data;
			commit('SET_HAVE_SELF_MCH', haveSelfMch);
			commit('SET_PAY_TO_USER', payToUser);
			commit('SET_HAVE_TRUE_SELF_MCH', haveTrueSelfMch);
		} catch (error) {
			errors(error);
		}
	},
	async getCurrentSmsAssets({ state, commit }, activityId) {
		if (state.smsAssets && activityId == state.smsAssets.id) {
			return;
		} else {
			try {
				const { ok, data } = await smsConsumeRecord.getById(activityId);
				if (ok) {
					data.data.isFree = Date.now() < data.data.smsFreeDueDate;
					data.data.id = activityId;
					commit('SET_SMS_ASSETS', data.data);
				}
			} catch (err) {
				errors(err);
			}
		}
	},
	async getAlbumsSmsAssets({ state, commit }, albumId) {
		if (state.smsAssets && albumId == state.smsAssets.id) {
			return;
		} else {
			try {
				const { data, ok } = await smsConsumeRecord.getByGatherId(albumId);
				if (ok) {
					data.data.isFree = Date.now() < data.data.smsFreeDueDate;
					data.data.id = albumId;
					commit('SET_SMS_ASSETS', data.data);
				}
			} catch (err) {
				errors(err);
			}
		}
	},
	async saveShipAddress({ state, commit }, params) {
		const activityId = state.currentActive.id;
		// 没有直播间id信息，说明当前信息还未获取，此时不执行功能
		if (!activityId) {
			return;
		}
		const body = Object.assign({}, params);
		const settingRes = await iconSwitch.save(activityId, body);
		if (settingRes.ok) {
			Message.success({
				message: settingRes.data.msg,
			});
		} else {
			Message.error({
				message: settingRes.data.msg,
			});
		}
		let obj = state.currentActive;
		let changeData = {
			iconSwitchShow: {},
		};
		for (let [key, value] of Object.entries(body)) {
			if (Object.prototype.hasOwnProperty.call(obj, key)) {
				changeData[key] = value;
			} else if (Object.prototype.hasOwnProperty.call(obj.iconSwitchShow, key)) {
				changeData.iconSwitchShow[key] = value;
			}
		}
		commit('SET_LIVE_CONTENT', changeData);
	},
	async updateActivity({ state, dispatch }, body) {
		try {
			const { data, ok } = await activity.updateActivity(state.currentActive.id, body);
			if (!ok) {
				return;
			}
			Message.success(data.msg);
			dispatch('getCurrentActive', state.currentActive.id);
		} catch (e) {
			errors(e);
		}
	},
	async updateIconSwitch({ state, dispatch }, body) {
		try {
			const { data, ok } = await iconSwitch.save(state.currentActive.id, body);
			if (!ok) {
				return;
			}
			Message.success(data.msg);
			dispatch('getCurrentActive', state.currentActive.id);
		} catch (e) {
			errors(e);
		}
	},
};
export const getters = {
	haveSmsAssets(state) {
		if (state.smsAssets) {
			return state.smsAssets.isFree || state.smsAssets.remainSmsNum;
		} else {
			return false;
		}
	},
	isWedding(state) {
		return state.currentActive.liveType == 1;
	},
	// 是否为2022-08-10上线前已存量直播间
	isOldReleseActivity(state) {
		// 2037911是上线前，直播间id的最大id数， 78256是测试环境的直播间最大id数
		const maxId = config.key === 'v1' ? 2037911 : 78256;
		return state.currentActive.id && state.currentActive.id < maxId;
	},
};
